import type { MapFeatureEdit } from "../types/MapFeatureEdit";
import type { PullInZone } from "../types/PullInZone";

/**
 * Turn the board's staged pull-in zone deltas into one `MapFeatureEdit` per touched job, sorted
 * by job id for a deterministic batch. A job with nothing staged and no clear produces no edit;
 * a job with both produces one edit carrying both (the server clears before it appends).
 */
export function buildMapFeatureEdits(
	stagedPullInZonesByJobId: ReadonlyMap<string, readonly PullInZone[]>,
	clearedPullInZoneJobIds: ReadonlySet<string>,
): MapFeatureEdit[] {
	const jobIds = [...new Set<string>([...stagedPullInZonesByJobId.keys(), ...clearedPullInZoneJobIds])].sort();
	const edits: MapFeatureEdit[] = [];
	for (const jobId of jobIds) {
		const add = (stagedPullInZonesByJobId.get(jobId) ?? []).map((zone) => zone.toFeature());
		const clear: MapFeatureEdit["clear"] = clearedPullInZoneJobIds.has(jobId) ? ["pullin"] : [];
		if (add.length === 0 && clear.length === 0) continue;
		edits.push({ jobId, add, clear });
	}
	return edits;
}
